import { useEffect } from 'react';
import store from './choose-store-location-store';
import { SelectDropdown } from '../../components/inputs/select-dropdown/select-dropdown';
import { observer } from 'mobx-react';
import { FormFieldLine } from '../../components/form-field-line/form-field-line';
import { Button } from '../../components/inputs/button/button';
import { Note } from '../../components/note/note';
import './choose-store-location.scss';
import { FONT_COLOR, FONT_VARIANT } from '../../components/fonts/font-props';
import FontHeading1 from '../../components/fonts/font-heading1/font-heading1';
import { Toggle } from '../../components/inputs/toggle/toggle';
import useDashboardTranslation from '../../dashboard-translation/hooks/dashboard-translation-hook';


const ChooseStoreLocationPage: React.FC = observer(() => {
    useEffect(() => {
        store.load();
    }, []);

    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-home';

    const selectedStore = store.shops.find(s => s.id === store.selectedStoreId);
    const title = selectedStore ? selectedStore.name + ' ' + getTranslation('RETURNS_MANAGEMENT', scope) : '';

    const storeSelectorOptions = store.shops.map(store => ({
        value: store.id,
        label: store.name
    }));

    const storeSelectorValue = storeSelectorOptions
        .find(option => option.value === store.selectedStoreId);

    const locationSelectorOptions = store.locations?.map(location => ({
        value: location.location_id,
        label: location.name
    }));

    const locationSelectorValue = locationSelectorOptions?.find(
        option => option.value === store.physicalStoreLocationId
    );

    return (
        <div className='choose-store-location'>
            <FontHeading1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{title}</FontHeading1>
            <FormFieldLine label={getTranslation('SELECT_STORE', scope)}>
                <SelectDropdown
                    placeholder={getTranslation('SELECT_STORE', scope)}
                    options={storeSelectorOptions}
                    value={storeSelectorValue}
                    onChange={v => store.setSelectedStoreId(v?.value as number)}
                    isLoading={store.isLoadingStores}
                    disabled={store.isSaving}
                />
            </FormFieldLine>
            <FormFieldLine label={getTranslation('SELECT_YOUR_STORE_LOCATION', scope)}>
                <SelectDropdown
                    placeholder={getTranslation('SELECT_LOCATION', scope)}
                    options={locationSelectorOptions}
                    value={locationSelectorValue}
                    onChange={v => store.setLocationId(v?.value as string)}
                    isLoading={store.isLoadingLocations}
                    disabled={store.isSaving}
                />
            </FormFieldLine>
            {store.physicalStoreLocationId && (
                <Note body={getTranslation('MAKE_SURE_YOU_SELECTED_CORRECT_STORE', scope)}/>
            )}
            <FormFieldLine label={getTranslation('REMEMBER_MY_SELECTION', scope)}>
                <Toggle
                    label={''}
                    checked={store.rememberSelection}
                    onChange={store.setRememberSelection}
                />
            </FormFieldLine>
            <div>
                <Button
                    onClick={store.saveLocationId}
                    text={getTranslation('CONTINUE', scope)}
                    disabled={!store.selectedStoreId ||
                        !store.physicalStoreLocationId ||
                        store.isLoadingStores ||
                        store.isSaving}
                />
            </div>
        </div>
    );
});

export default ChooseStoreLocationPage;
